import React, {FC, useEffect, useRef, useState} from "react";
import ReactInputMask from "react-input-mask";
import TableCalendar from "../../../TableCalendar/TableCalendar";
import {SupplierEmployee, WorkSchedule} from "../../../../constants/Supplier/SupplierEmployee";
import {t} from "i18next";
import Input from "../../../commons/Input/Input";
import Validations from "../Validations";
import PhoneInput from "../../../commons/Input/PhoneInput";
import classNames from "classnames";
import FormSelect, {ISelectOption} from "../../../commons/Select/FormSelect";


interface EmployeeProps {
    index: number,
    data: SupplierEmployee,
    updateDataHandler: (index:number, data: SupplierEmployee) => void,
    initialWorkScheduleValue: WorkSchedule,
}

const Employee: FC<EmployeeProps> = ({index, data, updateDataHandler, initialWorkScheduleValue}) => {

    const usePrevious = <T extends unknown>(value: T): T | undefined => {
        const ref = useRef<T>();
        useEffect(() => {
            ref.current = value;
        });
        return ref.current;
    };

    const [name, setName] = useState<string>(data.name || '')
    const prevName = usePrevious<string>(name) || ''
    const [email, setEmail] = useState<string>(data.email || '')
    const prevEmail = usePrevious<string>(email) || ''
    const [phone, setPhone] = useState<string>(data.phone || '')
    const prevPhone = usePrevious<string>(phone) || ''

    // Param - timezone
    const availableTimezoneOptions: {[key: string]: string} = {
        "-12:00": "-12:00",
        "-11:00": "-11:00",
        "-10:00": "-10:00",
        "-09:30": "-09:30",
        "-09:00": "-09:00",
        "-08:00": "-08:00",
        "-07:00": "-07:00",
        "-06:00": "-06:00",
        "-05:00": "-05:00",
        "-04:00": "-04:00",
        "-03:30": "-03:30",
        "-03:00": "-03:00",
        "-02:00": "-02:00",
        "-01:00": "-01:00",
        "+00:00": "+00:00",
        "+01:00": "+01:00",
        "+02:00": "+02:00",
        "+03:00": "+03:00",
        "+03:30": "+03:30",
        "+04:00": "+04:00",
        "+04:30": "+04:30",
        "+05:00": "+05:00",
        "+05:30": "+05:30",
        "+05:45": "+05:45",
        "+06:00": "+06:00",
        "+06:30": "+06:30",
        "+07:00": "+07:00",
        "+08:00": "+08:00",
        "+08:45": "+08:45",
        "+09:00": "+09:00",
        "+09:30": "+09:30",
        "+10:00": "+10:00",
        "+10:30": "+10:30",
        "+11:00": "+11:00",
        "+12:00": "+12:00",
        "+12:45": "+12:45",
        "+13:00": "+13:00",
        "+14:00": "+14:00",
    };
    const defaultTimezone = "+03:00"
    const [timezone, setTimezone] = useState<string>(data.timezone || defaultTimezone);
    const prevTimezone = usePrevious<string>(timezone) || defaultTimezone
    const [timezoneOptions, setTimezoneOptions] = useState<ISelectOption[]>([]);

    const [errors, setErrors] = useState({name: '', email: '', phone: ''});

    useEffect(() => {
        //
        const timezoneSelectOptions: ISelectOption[] = []
        for (const key in availableTimezoneOptions) {
            timezoneSelectOptions.push({text: availableTimezoneOptions[key], value: key})
        }
        setTimezoneOptions(timezoneSelectOptions)
    }, []);

    useEffect(() => {
        setName(data.name)
        setEmail(data.email)
        setPhone(data.phone)
        setTimezone(data.timezone || defaultTimezone)
    }, [data])

    useEffect(() => {
        console.log('useEffect - name')

        const validation = Validations();

        console.log('prevName', prevName, name)
        if (prevName != name) {
            errors.name = ''
            if (validation['name']) {
                validation['name'](errors, name)
            }
            data.name = name
            updateDataHandler(index, data)
        }
    }, [name])

    useEffect(() => {
        console.log('useEffect - email')

        const validation = Validations();

        console.log('prevEmail', prevEmail, email)
        if (prevEmail != email) {
            errors.email = ''
            if (validation['email']) {
                validation['email'](errors, email)
            }
            data.email = email
            updateDataHandler(index, data)
        }
    }, [email])

    useEffect(() => {
        console.log('useEffect - phone')

        const validation = Validations();

        if (prevPhone != phone) {
            errors.phone = ''
            if (validation['phone']) {
                validation['phone'](errors, phone)
            }
            data.phone = phone
            updateDataHandler(index, data)
        }
    }, [phone])

    useEffect(() => {
        console.log('useEffect - timezone')

        if (prevTimezone != timezone) {
            data.timezone = timezone
            updateDataHandler(index, data)
        }
    }, [timezone])

    function workScheduleDataUpdateHandler(workSchedule: WorkSchedule) {
        data.workSchedule = workSchedule
        updateDataHandler(index, data)
    }

    const customInputClassName = 'border-[#E2E8F0] mb-1 px-3 py-2 rounded-md text-sm shadow-sm placeholder-slate-400  w-full focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none'

    return (
        <>
            <div className="name">
                <Input
                    placeholder="Иванов Иван"
                    id={`employee_name_${index}`}
                    name={`employee_name_${index}`}
                    value={name}
                    label={t<string>("Name", { ns: "messages" })}
                    changeHandler={event => setName(event.target.value)}
                    customClassName={customInputClassName}
                    customLabelClassName="text-sm"
                    blurHandler={event => setName(event.target.value)}
                    validationError={errors.name.length > 0}
                    validationErrorDescription={errors.name}
                    type="text"
                    require={false}
                />
            </div>
            <div className="email my-4">
                <Input
                    placeholder="example@mail.com"
                    id={`employee_email_${index}`}
                    name={`employee_email_${index}`}
                    value={email}
                    label={t<string>("Email", { ns: "messages" })}
                    changeHandler={event => setEmail(event.target.value)}
                    customClassName={customInputClassName}
                    customLabelClassName="text-sm"
                    blurHandler={event => setEmail(event.target.value)}
                    validationError={errors.email.length > 0}
                    validationErrorDescription={errors.email}
                    type="email"
                    require={false}
                />
            </div>
            <div className="phone my-4">
                <PhoneInput
                    placeholder=""
                    id={`employee_phone_${index}`}
                    name={`employee_phone_${index}`}
                    value={phone}
                    label={t<string>("Телефон", { ns: "messages" })}
                    changeHandler={event => setPhone(event.target.value)}
                    customClassName={customInputClassName}
                    customLabelClassName="text-sm"
                    blurHandler={event => setPhone(event.target.value)}
                    validationError={errors.phone.length > 0}
                    validationErrorDescription={errors.phone}
                    require={false}
                />
            </div>
            <div
                className={
                    'flex text-sm text-gray-600 text-left font-medium pt-2 mb-1'
                }
            >
                График работы
                <span className="text-red-500">*</span>
            </div>
            <FormSelect
                id={`employee_timezone_${index}`}
                name={`employee_timezone_${index}`}
                value={timezone}
                label={t<string>("Часовой пояс", { ns: "messages" })}
                changeHandler={event => setTimezone(event.target.value)}
                customClassName={classNames(customInputClassName)}
                customLabelClassName="text-sm"
                blurHandler={event => setTimezone(event.target.value)}
                validationError={false}
                validationErrorDescription={''}
                options={timezoneOptions}
                require={false}
            ></FormSelect>
            <TableCalendar
                data={data.workSchedule}
                updateDataHandler={workScheduleDataUpdateHandler}
                initialWorkScheduleValue={initialWorkScheduleValue}
            />
        </>
    )
}

export default Employee
